export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '6da86ec7-e610-4491-b125-53c394bb80e1';
export const MODAL_CLOSE_SEC = 2.5;
